// extracted by mini-css-extract-plugin
module.exports = {"list":"FilterByTypeDropdown_list__oWziq"};